// Navigation data:
export const navbarData = {
    title: "Pixel Port",
    dashboard_btn_txt: "Dashboard",
    home_btn_txt: "Home",
    marketplace_btn_txt: "Marketplace",
}